import React from 'react';
import c from 'classnames';
import Slider from '@wix/da-ds/pkg/Slider';
import { BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import SliderArrowButton from '../SliderArrowButton';
import s from './PanelSlider.scss';
const PanelSlider = ({ children, gradient = 'secondary' })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['overflow-wrapper']
    }, /*#__PURE__*/ React.createElement(Slider, {
        className: s['slider'],
        permArrows: true,
        onScrollBiData: {
            sectionname: BiContextProvidedValue
        },
        renderPrevButton: ({ onClick, className: prevButtonClassName })=>/*#__PURE__*/ React.createElement("div", {
                className: c(s['gradient-and-button'], s['left'], prevButtonClassName)
            }, /*#__PURE__*/ React.createElement(SliderArrowButton, {
                direction: "left",
                onClick: onClick,
                className: s['arrow-button']
            }), /*#__PURE__*/ React.createElement("div", {
                role: "presentation",
                className: c(s['gradient'], gradient === 'secondary' && s['gradient-secondary'], gradient === 'primary' && s['gradient-primary'])
            })),
        renderNextButton: ({ onClick, className: nextButtonClassName })=>/*#__PURE__*/ React.createElement("div", {
                className: c(s['gradient-and-button'], s['right'], nextButtonClassName)
            }, /*#__PURE__*/ React.createElement(SliderArrowButton, {
                direction: "right",
                onClick: onClick,
                className: s['arrow-button']
            }), /*#__PURE__*/ React.createElement("div", {
                role: "presentation",
                className: s['gradient']
            }))
    }, children));
};
PanelSlider.displayName = 'PanelSlider';
export default PanelSlider;

//# sourceMappingURL=PanelSlider.js.map